import type { CreateOrgType, MembershipRole } from '@/shared/domain'
import { roleLabel } from '@/shared/domain'

export type RoleLabelProps = {
  role: MembershipRole
  orgType: CreateOrgType
}

export function RoleLabel({ role, orgType }: RoleLabelProps) {
  return <span className="text-xs text-muted-foreground">{roleLabel(role, orgType)}</span>
}
